import { render, staticRenderFns } from "./defect.vue?vue&type=template&id=198673b6&scoped=true&"
import script from "./defect.vue?vue&type=script&lang=js&"
export * from "./defect.vue?vue&type=script&lang=js&"
import style0 from "./defect.vue?vue&type=style&index=0&id=198673b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198673b6",
  null
  
)

export default component.exports